import { FilterMatchMode } from 'primevue/api';

export const filterDefault = { value: null, matchMode: FilterMatchMode.CONTAINS };